import Link from "antd/es/typography/Link";
import { RightOutlined } from '@ant-design/icons';
import { cancelConsultationIcon, completeConsultationIcon, consultationIcon, upcomingConsultationIcon } from "../../../../assets/images";
import { consultationChartDetails } from "../config";
import BarChart from "./BarChart";

const ConsultationChart = ({
    handleScreenNavigation,
    dashboardData
}) => {
    return <>
        <div className="flexible">
            <h6 style={{ fontWeight: 700 }}>Consultation</h6>
            <Link style={{ fontWeight: 700 }} onClick={() => handleScreenNavigation("consultation")}>See More <RightOutlined /></Link>
        </div>
        <div className="flexible-start">
             <div className="consultation-chart-card">
                <div className="d-flex justify-content-left gap-2">
                    <img src={consultationIcon} alt="" />
                    <p className="consultation-chartcard-title">Total Cons.</p>
                </div>
                <h3 className="fw-bold mb-0 fs-6"> {dashboardData?.totalConsultation}</h3>
                <small className="todays-count">Today Cons.: <span>{dashboardData?.todayConsultation}</span></small>
            </div>
            <div className="consultation-chart-card">
                <div className="d-flex justify-content-left gap-2">
                    <img src={consultationIcon} alt="" />
                    <p className="consultation-chartcard-title">Total Auto Cancel Cons.</p>
                </div>
                <h3 className="fw-bold mb-0 fs-6"> {dashboardData?.autoCancelledConsultation}</h3>
                <small className="todays-count">Today Auto Cancel: <span>{dashboardData?.todayAutoCancelledConsultation}</span></small>
            </div>
            <div className="consultation-chart-card">
                <div className="d-flex justify-content-left gap-2">
                    <img src={completeConsultationIcon} alt="" />
                    <p className="text-success consultation-chartcard-title">Total Complete Cons.</p>
                </div>
                <h3 className="fw-bold mb-0 text-success fs-6">{dashboardData?.completeConsultation}</h3>
                <small className="todays-count">Completed Today : <span>{dashboardData?.toadyCompleteConsultation}</span></small>
            </div>
            <div className="consultation-chart-card">
                <div className="d-flex justify-content-left gap-2">
                    <img src={upcomingConsultationIcon} alt="" />
                    <p className="consultation-chartcard-title" style={{ color: "#CA6500" }}>Total Upcoming Cons.</p>
                </div>
                <h3 className="fw-bold mb-0 fs-6" style={{ color: "#CA6500" }}> {dashboardData?.upComingConsultation}</h3>
                <small className="todays-count">Pending Today : <span></span>{dashboardData?.todayUpComingConsultation}</small>
            </div>
            <div className="consultation-chart-card">
                <div className="d-flex justify-content-left gap-2">
                    <img src={cancelConsultationIcon} alt="" />
                    <p className="text-danger consultation-chartcard-title">Total Cancelled Cons.</p>
                </div>
                <h3 className="fw-bold mb-0 text-danger fs-6"> {dashboardData?.cancelledConsultation}</h3>
                <small className="todays-count">Cancelled Today : <span>{dashboardData?.todayCancelledConsultation}</span></small>
            </div>
        </div>
        <div style={{ width: "100%", position: "relative", padding: "0px 10px" }}>
            <BarChart configData={consultationChartDetails} data={consultationChartDetails?.map((detail) => dashboardData?.[detail?.key])} horizontal={true} />
        </div>
    </>
};
export default ConsultationChart